import './index.less'

export default {
  data:() => ({
    stats:{}
  }),
  created(){
    this.$request.screenCarStats().then(resp => {
      if( resp.code == 0 ){
        for(let key of Object.keys(resp.data)){
          resp.data[key] = resp.data[key] //* 2
        }
        this.stats = resp.data
      }
    })
  },
  render(){
    let stats = this.stats
    return <div class="screen-car-stats">
      <div class="screen-car-stats-item">{stats.insurance}<div>保险车辆</div></div>
      <div class="screen-car-stats-item">{stats.insuranceNot}<div>无保车辆</div></div>
      <div class="screen-car-stats-item">{stats.insuranceExpired}<div>保险到期</div></div>
      <div class="screen-car-stats-item">{stats.fenceNum}<div>收派围栏</div></div>
    </div>
  }
}